import React from 'react';
import { routes as globalRoutes } from '../../routes';
import { PersonalDocuments } from './PersonalDocuments';

export const routes = () => ({
  personal: {
    route: globalRoutes.documentsPersonal.route,
    render: () => <PersonalDocuments />,
  },
});
